import UIStrings from '@/Utils/UIStrings';

const affiliateLogos = [
    { src: '/resources/login/companies/aig.svg', alt: 'AIG', className: 'h-8' },
    { src: '/resources/login/companies/moove.svg', alt: 'Moove', className: 'h-8' },
    { src: '/resources/login/companies/volkswagen.svg', alt: 'Volkswagen', className: 'h-6.5' },
    { src: '/resources/login/companies/cgm-alt.svg', alt: 'CompuGroup Medical', className: 'h-7' },
    { src: '/resources/login/companies/hpf.svg', alt: 'Human Practice Foundation', className: 'h-[25px]' },
] as const;

function AffiliateLogos() {
    return (
        <div className="border-border mx-auto w-full max-w-110 shrink-0 border-t pt-4.5">
            <p className="text-muted-foreground mb-3 text-center text-[11.5px] font-semibold tracking-widest uppercase">
                {UIStrings.HelpedLeadingTeamsRecruit}
            </p>
            <ul className="m-0 flex list-none flex-wrap items-center justify-center gap-x-6 gap-y-4 p-0 min-[480px]:flex-nowrap min-[480px]:justify-between min-[480px]:gap-3">
                {affiliateLogos.map((logo) => (
                    <li key={logo.alt}>
                        <img
                            src={logo.src}
                            alt={logo.alt}
                            className={`w-auto opacity-60 grayscale ${logo.className}`}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default AffiliateLogos;
